import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_PL.json';
import recipes from './COOKING_RECIPES_PL.json';
import videos from './COOKING_VIDEOS_PL.json';

export const COOKING_DATA_PL: ServiceData = {
  articles,
  recipes,
  videos,
};
